module.exports = __webpack_public_path__ + "static/media/7.b42d160f.jpg";